module.exports = __webpack_public_path__ + "static/media/user-friendly.775019df.svg";